export default [
    {
        path: '/relation/index',
        name: 'relation/index',
        meta: {
            title: "数据关联"
        },
        component: () => import('@/views/relation/index'),
    },{
        path: '/relation/second',
        name: 'second',
        meta: {
            title: "二级包装关联"
        },
        component: () => import('@/views/relation/second'),
    },{
        path: '/relation/three',
        name: 'three',
        meta: {
            title: "三级包装关联"
        },
        component: () => import('@/views/relation/three'),
    },{
        path: '/relation/dismiss',
        name: 'dismiss',
        meta: {
            title: "解除包装关联"
        },
        component: () => import('@/views/relation/dismiss'),
    },
    {
      path: '/relation/codeRule',
      name: 'codeRule',
      meta:{
        title:"二维码规则"
      },
      component: () => import('@/views/relation/codeRule')
    },
    {
      path: '/relation/ct_second',
      name: 'ct_second',
      meta: {
          title: "成套二级包装关联"
      },
      component: () => import('@/views/relation/ct_second'),
  },{
      path: '/relation/ct_three',
      name: 'ct_three',
      meta: {
          title: "成套三级包装关联"
      },
      component: () => import('@/views/relation/ct_three'),
  },
    {
    path: "/relation/packageRelation",
    name: "packageRelation",
    meta: {
      title: "箱盒关联"
    },
    component: () => import("@/views/relation/packageRelation")
  },
  {
    path: "/relation/bottlePackageRelation",
    name: "bottlePackageRelation",
    meta: {
      title: "盒瓶关联"
    },
    component: () => import("@/views/relation/bottlePackageRelation")
  },
  {
    path: "/relation/offLinePackageRelation",
    name: "offLinePackageRelation",
    meta: {
      title: "离线箱盒关联"
    },
    component: () => import("@/views/relation/offLinePackageRelation")
  },
  {
    path: "/relation/offLineBottlePackageRelation",
    name: "offLineBottlePackageRelation",
    meta: {
      title: "离线盒瓶关联"
    },
    component: () => import("@/views/relation/offLineBottlePackageRelation")
  },

]
